// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"05ffbaf9","1060":"f6e8aeaa","1373":"f6e8aeaa","2572":"d8c8afa0","3243":"aecce36d","4172":"7b77520a","4660":"f6e8aeaa","7808":"f6e8aeaa"}[chunkId] + ".chunk.css";
};